(function() {
    'use strict';

    angular
        .module('app.service')
        .factory('mobileService', mobileService);

    function mobileService(apiUrl, $http, $q) {
        var service = {
            postMobileInfo: postMobileInfo,
            postCourseInfo: postCourseInfo
        };

        return service;

        ////////////////
        function postMobileInfo(data) {
            // 通知 APP 登入成功 (給予 token 資料)
            //alert('DEVICE_TYPE:',DEVICE_TYPE);
            if (DEVICE_TYPE) {
                var params = {
                    token: data.Token
                };
                var method = "login";
                appCallback(method, params);
            }
            var param = {
                DEVICE_TYPE: DEVICE_TYPE,
                DEVICE_TOKEN: DEVICE_TOKEN,
                USER_TOKEN: data.Token,
                PerSerilNo: data.PerSerilNo || data.PerserilNo,
            };
            var isMobileApp = true;

            if (!param.DEVICE_TOKEN || DEVICE_TOKEN.length < 1) {
                isMobileApp = false;
            } else {
                if (param.DEVICE_TYPE !== '' && param.DEVICE_TYPE !== '(null)' && param.DEVICE_TYPE.toLowerCase() === 'ios') {
                    var message = { 'DEVICE_TOKEN': param.DEVICE_TOKEN, 'DEVICE_TYPE': param.DEVICE_TYPE };
                    window.webkit.messageHandlers.msgHandler.postMessage(message);
                }
            }
            if (!isMobileApp) {
                return $q.when({});
            }
            $http.post(apiUrl.tsApi + 'mobile', param);
        }

        function postCourseInfo(params) {
            window.webkit.messageHandlers.msgHandler.postMessage(JSON.stringify(params));
        }
    }
})();